import type { IClaim } from "@api/models/IClaim";
import { create } from "zustand";

interface RewardModalStore {
  item: IClaim | undefined;
  isOpened: boolean;
  open: (item: IClaim) => void;
  close: () => void;
}

const useRewardModalStore = create<RewardModalStore>()((set) => ({
  item: undefined,
  isOpened: false,
  open: (item) => set({ item, isOpened: true }),
  close: () => {
    set({ isOpened: false });
    // time to play animation right without data being erased visually
    setTimeout(() => set({ item: undefined }), 150);
  },
}));

export default useRewardModalStore;
